import React from 'react';
import ReactSlick from 'react-slick';
import { block } from 'bem-cn';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './carousel.scss';

const b = block('carousel');

export type CarouselPropsType = {
  children: any; // TODO : should be ReactNode,
  settings: Record<string, any>;
};

const Carousel = ({ children, settings = {} }: CarouselPropsType) => {
  const defaultSettings = {
    dots: true,
    arrows: true,
    speed: 500,
    infinite: false,
  };

  const mergedSettings = {
    ...defaultSettings,
    ...settings,
  };

  return (
    <ReactSlick {...mergedSettings} className={b()}>
      {children}
    </ReactSlick>
  );
};

export default Carousel;
